(function () {
    const openSearchButton = document.getElementById('open-search');
    const searchBar = document.querySelector('.search-bar');
    if (openSearchButton && searchBar) {
        openSearchButton.addEventListener('click', () => {
            searchBar.classList.remove('search-bar--hidden');
            searchBar.querySelector('.search-bar__input').focus();

            document.querySelectorAll('.header__menu-item').forEach(element => {
                element.classList.add('header__menu-item--hidden');
            })
            document.querySelector('.search__img').classList.add('search__img--hidden');
        })

        const closeSearchBarButton = document.querySelector('.search-bar__back');
        closeSearchBarButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.search-bar').classList.add('search-bar--hidden');
            document.querySelectorAll('.header__menu-item').forEach(element => {
                element.classList.remove('header__menu-item--hidden');
            })
            document.querySelector('.search__img').classList.remove('search__img--hidden');
        })
    }
})();